<body class="h-full flex flex-col overflow-hidden bg-default">
  <mp-navbar />
  <mp-loader />
  <div class="flex-1 overflow-auto px-2">
    <router-outlet />
  </div>
  @if (responsiveService.screenSize() >= responsiveService.screenSizeEnum.MEDIUM) {
    <mp-footer />
  }
</body>
